<template>
  <div>
    <SelectGameToPlayPopup :ref="(el: any) => popups.selectGameToPlayPopup = el"></SelectGameToPlayPopup>
    <LootboxPopup :ref="(el: any) => popups.lootboxPopup = el"></LootboxPopup>
    <InternalStorePopup :ref="(el: any) => popups.internalStorePopup = el"></InternalStorePopup>
    <WheelOfFortunePopup :ref="(el: any) => popups.wheelOfFortunePopup = el"></WheelOfFortunePopup>
  </div>
</template>

<script setup lang="ts">
import WheelOfFortunePopup from "@/components/popups/WheelOfFortunePopup.vue";
import InternalStorePopup from "@/components/popups/InternalStorePopup.vue";
import SelectGameToPlayPopup from "@/components/popups/SelectGameToPlayPopup.vue";
import {ref} from "vue";
import LootboxPopup from "@/components/popups/LootboxPopup.vue";

const popups = {
  wheelOfFortunePopup: ref<InstanceType<typeof WheelOfFortunePopup> | null>(null),
  internalStorePopup: ref<InstanceType<typeof InternalStorePopup> | null>(null),
  selectGameToPlayPopup: ref<InstanceType<typeof SelectGameToPlayPopup> | null>(null),
  lootboxPopup: ref<InstanceType<typeof LootboxPopup> | null>(null),
}

const getPopups = () => {
  return popups;
}
defineExpose({ getPopups })
</script>